import { clearString } from "../assets/constants/strings";
import pluralize from 'pluralize';
import { search } from "./axios";
import store from "../store";

export const RGuidesRegex = /(regulatory)(\s?(guide))(\s?\d*)?\b|\b(rg)(\s?\d*)?\b|\b(regulatory)(\s?(guide))\b|\b(regulatory(\s?\d*)?)\b|\b(guide(\s?\d*)?)\b(regulatory)(\s?(guide))(\s?\d*)?\b|\b(rg)(\s?\d*)?\b|\b(regulatory)(\s?(guide))\b|\b(regulatory(\s?\d*)?)\b|\b(guide(\s?\d*)?)\b/gi;

/**
 * Refined search algorithm to pick up "RG" if you search for Regulatory Guide
 * @param {string} input The search param.
 * @param {Array<object>} documents The array with all docs.
 * @param {Array<{ key: string; value: string | Date; type: string; active?: boolean }>} filters The filters to perform advanced search.
 * @returns {Array<object>} The Array of matched docs.
 */
export const RGTitleSearch = (input, documents, filters) => {
  let matchedDocs = [];
  if (documents && documents.length > 0) {

    input = clearString(input.trim());

    let breakWord = false;

    // advanced search
    if (filters && filters.length > 0) {
      // filtering logic before normal search regex to increase performance
      filters.forEach((filter) => {
        // if its not the default value
        if (filter.value !== '-All-' && filter.type === 'equal') {
          if (filter.key.match('level')) {
            documents = documents.filter((doc) => (
              doc[filter.key] !== null && doc[filter.key].Title === filter.value
            ));
          }
        } else if (filter.type === 'smaller') {
          documents = documents.filter((doc) => doc[filter.key] <= filter.value);
        } else if (filter.type === 'larger') {
          documents = documents.filter((doc) => doc[filter.key] >= filter.value);
        }
      });
    }

    // user is searching for an RG
    if (input.match(RGuidesRegex)) {
      // do not allow word breaks if searching for specific RGs
      breakWord = true;

      const RGNumber = input.match(/\d{1,}\b/);

      if (RGNumber) {
        // try to match the number present
        documents.forEach((doc) => {
          const regExWord = new RegExp(`\\b(regulatory\\s?guide\\s?${RGNumber[0]})\\b|\\b(rg\\s?${RGNumber[0]})\\b`, 'gi');
          if (doc.title.match(regExWord)) matchedDocs.push(doc);
        });
      } else {
        // try to match just RG
        documents.forEach((doc) => {
          const regExWord = new RegExp(/\b(regulatory\s?guide(\s?\d*)?)\b|\b(rg(\s?\d*)?)\b/, 'gi');
          if (doc.title.match(regExWord)) matchedDocs.push(doc);
        });
      }
    }

    // then do normal search and add if not already present
    documents.forEach((doc) => {
      const regExWord = new RegExp(breakWord ? `(\\b${input}\\b)` : `(${input})`, 'gi');
      if (!matchedDocs.some((Doc) => Doc.id === doc.id) && doc.title.match(regExWord)) matchedDocs.push(doc);
    });
  }

  return matchedDocs;
};

export const SearchPHP = async (input, substringSearch) => {
  const inputSingular = pluralize.singular(input.trim());
  const inputPlural = pluralize(input.trim());

  const spKey = store.getState().user.user.spKey;

  return await search({
    singular: inputSingular,
    plural: inputPlural,
    subString: substringSearch,
  }, spKey);
};

export const filterPages = (pages, filters) => {
  // filtering logic
  filters.forEach((filter) => {
    // if its not the default value
    if (filter.value !== '-All-' && filter.type === 'equal') {
      pages = pages.filter((page) => page[filter.key] === filter.value);
    } else if (filter.type === 'smaller') {
      pages = pages.filter((page) => page[filter.key] <= filter.value);
    } else if (filter.type === 'larger') {
      pages = pages.filter((page) => page[filter.key] >= filter.value);
    }
  });

  return pages;
};
